export default __webpack_public_path__ + "static/media/first-time-login.03968df0.png";